import React from 'react';
import {
  Button,
  Input,
  Modal,
  ModalHeader,
  Col,
  Label,
  ModalFooter,
} from 'reactstrap';

export const ModalHistoryStatus = ({ isOpen, toggle, handleSubmit }) => {
  return (
    <Modal
      isOpen={isOpen}
      toggle={() => {
        toggle();
      }}
      zIndex={10000}
      backdrop={'static'}
      id="staticBackdrop"
      centered
    >
      <ModalHeader>Novo Evento</ModalHeader>
      <div className="modal-body">
        <form
          autoComplete="off"
          onSubmit={(e) => {
            e.preventDefault();
            handleSubmit(e);
          }}
        >
          <Col md={12}>
            <div className="mb-3">
              <Label htmlFor="subjectInput" className="form-label">
                Assunto
              </Label>
              <Input
                type="text"
                id="subjectInput"
                placeholder="Resumo do evento"
              />
            </div>
          </Col>

          <Col md={12}>
            <div className="mb-3">
              <Label htmlFor="detailsInput" className="form-label">
                Detalhes
              </Label>
              <Input
                id="detailsInput"
                aria-multiline
                type="textarea"
                className="form-control"
                style={{
                  height: 100,
                }}
              />
            </div>
          </Col>

          <div className="text-end">
            <button
              className="btn btn-link"
              onClick={() => {
                toggle();
              }}
              type="button"
            >
              {' '}
              Cancelar{' '}
            </button>
            <Button color="primary" type="submit">
              {' '}
              Salvar{' '}
            </Button>
          </div>
        </form>
      </div>
    </Modal>
  );
};
